class AccordionController extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		document.addEventListener('header-sidebar:items-revealing', this.openOpenedByDefaultAccordion.bind(this));
		this.accordions = this.querySelectorAll('accordion-disclosure');
		if (this.accordions.length === 0) {
			return;
		}
		this.accordions.forEach((selectedAccordion) => {
			selectedAccordion.addEventListener('click', () => {
				this.closeOpenedAccordions(selectedAccordion);
			});
		});
	}

	closeOpenedAccordions(selectedAccordion) {
		this.accordions.forEach((accordion) => {
			if (accordion !== selectedAccordion && accordion.open) {
				accordion.close();
			}
		});
	}

	openOpenedByDefaultAccordion() {
		this.accordions.forEach((accordion) => {
			if (accordion.querySelector('[open-by-default]') && !accordion.firstChild.open) {
				accordion.open();
			}
		});
	}
}

if (!customElements.get('accordion-controller')) {
	customElements.define('accordion-controller', AccordionController);
}
